import { useState } from 'react';
import { callUIAPI } from '../../../utils/apiUtils';
import * as apiConstants from '../../../utils/apiUtilsConstants';
import { FIRM_ACCOUNT_TYPE_OPTIONS } from '../../../utils/firmAccountTypeConstants';

const PHONE_PATTERN = /^\+?[0-9][0-9\s().-]{6,19}$/;

const FIELD_HEIGHT = '38px';

const fieldStyle = {
  height: FIELD_HEIGHT,
  boxSizing: 'border-box',
  padding: '0 10px',
  borderRadius: '6px',
  border: '1px solid #d1d5db',
  fontSize: '14px',
  fontFamily: 'inherit',
  lineHeight: 'normal',
  backgroundColor: '#ffffff',
  color: '#111827',
};

const FirmProfile = ({ firm, onFirmUpdate }) => {
  const [accountType, setAccountType] = useState(firm.accountType || '');
  const [phone, setPhone] = useState(firm.phone || '');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const isDirty =
    (accountType || '') !== (firm.accountType || '') ||
    (phone || '').trim() !== (firm.phone || '');

  const handleSave = async () => {
    const trimmedPhone = phone.trim();
    if (trimmedPhone && !PHONE_PATTERN.test(trimmedPhone)) {
      setMessage(null);
      setError('Please enter a valid phone number.');
      return;
    }

    setIsSaving(true);
    setError(null);
    setMessage(null);
    try {
      const response = await callUIAPI(
        `bo/firms/${firm.id}/profile`,
        { accountType: accountType || null, phone: trimmedPhone || null },
        apiConstants.METHOD_PUT,
        true,
      );
      const updated = response.data.item;
      onFirmUpdate(updated);
      setAccountType(updated.accountType || '');
      setPhone(updated.phone || '');
      setMessage('Saved.');
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to save firm details.');
    } finally {
      setIsSaving(false);
    }
  };

  const isSaveDisabled = isSaving || !isDirty;

  return (
    <div>
      <h3 style={{ margin: '0 0 12px', fontSize: '15px', fontWeight: 600 }}>Firm Details</h3>

      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '220px' }}>
          <label htmlFor="firm-account-type" style={{ fontSize: '13px', color: '#6b7280' }}>Firm Type</label>
          <select
            id="firm-account-type"
            value={accountType}
            onChange={(e) => setAccountType(e.target.value)}
            disabled={isSaving}
            style={fieldStyle}
          >
            <option value="">Not Set</option>
            {FIRM_ACCOUNT_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '220px' }}>
          <label htmlFor="firm-phone" style={{ fontSize: '13px', color: '#6b7280' }}>Phone</label>
          <input
            id="firm-phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            disabled={isSaving}
            placeholder="Not provided"
            style={fieldStyle}
          />
        </div>

        <button
          type="button"
          onClick={handleSave}
          disabled={isSaveDisabled}
          style={{
            height: FIELD_HEIGHT,
            boxSizing: 'border-box',
            padding: '0 16px',
            borderRadius: '6px',
            border: 'none',
            fontSize: '14px',
            fontFamily: 'inherit',
            cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
            backgroundColor: isSaveDisabled ? '#e5e7eb' : '#1e40af',
            color: isSaveDisabled ? '#6b7280' : '#ffffff',
          }}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </button>
      </div>

      {error ? <p style={{ color: '#991b1b', fontSize: '13px', marginTop: '8px' }}>{error}</p> : null}
      {message ? <p style={{ color: '#166534', fontSize: '13px', marginTop: '8px' }}>{message}</p> : null}
    </div>
  );
};

export default FirmProfile;